import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setError("Les mots de passe ne correspondent pas"); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/admin/login"), 2000);
    } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); setLoading(false); }
  };

  return (
    <div className="flex min-h-[100dvh] items-center justify-center caneat-doodle-bg px-5">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm rounded-3xl bg-white p-7 shadow-2xl">
        <div className="mb-5 flex flex-col items-center text-center">
          <img src="/brand/caneat-logo-orange.png" alt="CAN'EAT" className="h-16 w-auto" />
          <h1 className="caneat-title mt-3 text-2xl text-caneat-ink">Nouveau mot de passe</h1>
        </div>
        {!token ? (
          <p className="text-center text-sm font-bold text-red-500">Lien invalide. Demande un nouveau lien à un Super Admin.</p>
        ) : done ? (
          <div className="flex flex-col items-center text-center">
            <CheckCircle2 className="h-14 w-14 text-emerald-500" />
            <p className="mt-3 text-sm font-bold text-caneat-ink">Mot de passe mis à jour ! Redirection…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required placeholder="Nouveau mot de passe" data-testid="reset-pw"
              className="w-full rounded-xl border-2 border-caneat-cream bg-caneat-pageCream px-4 py-3 text-sm font-semibold outline-none focus:border-caneat-orange" />
            <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required placeholder="Confirmer" data-testid="reset-pw2"
              className="w-full rounded-xl border-2 border-caneat-cream bg-caneat-pageCream px-4 py-3 text-sm font-semibold outline-none focus:border-caneat-orange" />
            {error && <p className="text-sm font-bold text-red-500">{error}</p>}
            <button type="submit" disabled={loading} data-testid="reset-submit"
              className="flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-caneat-orange text-base font-extrabold uppercase text-white disabled:opacity-60">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><KeyRound className="h-4 w-4" /> Valider</>}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
